class LoopMover
{
    constructor( options )
    {
        this.loopMover = document.querySelectorAll('.loopMover')
    }

    setMoving(element) {
        const base = parseFloat(element.getAttribute('data-base') || 0)
        const items = element.querySelectorAll('.loopMover__item')
        let width = 0

        items.forEach(item => {
            width += item.offsetWidth
        });
        // const item = element.offsetWidth
        const item = width
        element.style.width = `${width}px`

        if(item) {
            const transition =  item * base
            element.style.animationDuration = `${transition}s`
            setTimeout(() => {
                element.classList.add('move')
            }, 10);
        }
    }

    initMoving() {
        this.loopMover.forEach(element => {
            this.setMoving(element)
        });
    }

    init() {
        if(document.querySelector('.loopMover')) {
            this.initMoving()
        }
    }
}
export default LoopMover
